import { gql } from 'graphql-request';

import {
  CompanyTabCompanyID,
  CompanyTabCreatedAt,
  CompanyTabID,
  CompanyTabName,
  CompanyTabNanoID,
  CompanyTabPosition,
  CompanyTabType,
  CompanyTabUpdatedAt,
  CompanyTabUser,
  CompanyTabUserID,
  CompanyTabUUID
} from '../companyTabsTypes';

import { CreateItemGqlError } from '../../../types';

export interface CreateCompanyTabQueryResponse {
  createCompanyTab: {
    status: string;
    recordUuid: CompanyTabUUID;
    record: {
      id: CompanyTabID;
      uuid: CompanyTabUUID;
      nanoId: CompanyTabNanoID;
      name: CompanyTabName;
      content: string | null;
      position: CompanyTabPosition;
      type: CompanyTabType;
      createdAt: CompanyTabCreatedAt;
      updatedAt: CompanyTabUpdatedAt;
      userId: CompanyTabUserID;
      user: CompanyTabUser;
      companyId: CompanyTabCompanyID;
    };
    errors: {
      name: CreateItemGqlError;
      content: CreateItemGqlError;
      position: CreateItemGqlError;
      fullMessages: string[];
    };
  };
}

export const CREATE_COMPANY_TAB_QUERY = gql`
  mutation CreateCompanyTab(
    $nanoId: NanoId
    $companyId: Id!
    $name: String!
    $content: String
    $position: Int
  ) {
    createCompanyTab(
      input: {
        nanoId: $nanoId
        companyId: $companyId
        name: $name
        content: $content
        position: $position
      }
    ) {
      errors {
        fullMessages
        name
        content
        position
      }
      record {
        content
        createdAt
        id
        name
        nanoId
        position
        type
        updatedAt
        userId
        uuid
        user {
          id
          nanoId
        }
        companyId
      }
      recordUuid
      status
    }
  }
`;
